module.exports = __webpack_public_path__ + "static/media/defaultProfile.083ca120.png";